export enum SALE_STATUS {
  UPCOMING = 'UPCOMING',
  CURRENT = 'CURRENT',
  COMPLETED = 'COMPLETED',
}
